import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import { admin, errText, fmtDate } from "../../lib/adminApi";

export const EnquiriesPanel = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await admin.get("/admin/contacts", { params: { q: q || undefined } });
      setItems(data.items);
    } catch (e) {
      toast.error(errText(e?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="admin-enquiries">
      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative mb-6">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <input data-testid="admin-enquiries-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, email, company, service…" className="w-full bg-white/[0.04] border border-white/10 rounded-xl pl-10 pr-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-brand-orange" />
      </form>
      {loading ? (
        <p className="text-slate-500 text-sm py-10 text-center">Loading…</p>
      ) : items.length === 0 ? (
        <div data-testid="admin-enquiries-empty" className="glass rounded-2xl p-10 text-center text-slate-500 text-sm">No enquiries match.</div>
      ) : (
        <div className="space-y-3">
          {items.map((c) => (
            <div key={c.id} data-testid={`admin-enquiry-${c.id}`} className="glass rounded-2xl p-5">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="text-white font-medium">{c.name} {c.company && <span className="text-slate-500">· {c.company}</span>}</p>
                  <p className="text-xs text-slate-400 mt-0.5"><a href={`mailto:${c.email}`} className="text-brand-orange hover:underline">{c.email}</a>{c.phone && <> · <a href={`tel:${c.phone}`} className="hover:text-white">{c.phone}</a></>}</p>
                </div>
                <div className="text-right">
                  <span className="px-2.5 py-1 rounded-full text-[11px] font-medium bg-brand-orange/15 text-brand-orange">{c.service}</span>
                  <p className="text-[11px] text-slate-500 mt-1.5">{fmtDate(c.created_at)}</p>
                </div>
              </div>
              <p className="text-slate-300 text-sm mt-3 leading-relaxed whitespace-pre-wrap">{c.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EnquiriesPanel;
